
import { PhoneNumber } from './phone-number.model';

export class PhoneList {
  Phones: PhoneNumber[];
}
